export default __webpack_public_path__ + "static/media/prod-page-hidraulica.e3b16150.jpg";